export const getPixelSizeForLayoutSize = (layoutSize: number) => layoutSize;
